import Vue from 'vue'
import Router from 'vue-router'
import Tool from '@/components/Tool'
import AvisoPrivacidad from '@/components/AvisoPrivacidad'
import Portafolio from '@/components/Portafolio'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Tool',
      component: Tool
    },
    {
      path: '/notice-of-privacy',
      name: 'AvisoPrivacidad',
      component: AvisoPrivacidad
    },
    {
      path: '/portafolio',
      name: 'Portafolio',
      component: Portafolio
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js